<template>
  <b-modal
    id="modal-EmpresaServicio"
    size="lg"
    v-model="Show"
    @hide="CerrarModal"
    title="Nuevo Servicio"
    hide-footer
    body-class="myDiv"
  >
    <form action="">
      <div class="form-row">
        <b-form-group
          id="input-group-3"
          label="Plan"
          label-for="input-1"
          class="col-md-12"
        >
          <b-form-select
            id="idplan"
            value-field="idplan"
            text-field="detalle"
            :options="ListaPlanes"
            v-model="PlanUsuario.idplan"
            class="p-2 px-4 btn-xs"
          >
          </b-form-select>
        </b-form-group>
      </div>
      <div class="form-row">
        <b-form-group
          id="input-group-3"
          label="Fecha de Inincio de Servicio"
          label-for="input-1"
          class="col-md-6"
        >
          <b-form-datepicker
            id="inicio"
            v-model="PlanUsuario.fechainicio"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
            class="mb-2"
          ></b-form-datepicker>
        </b-form-group>
        <b-form-group
          id="input-group-3"
          label="Fecha de Vencimiento"
          label-for="input-1"
          class="col-md-6"
        >
          <b-form-datepicker
            id="vencimiento"
            v-model="PlanUsuario.fechafin"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
            class="mb-2"
          ></b-form-datepicker>
        </b-form-group>
      </div>
      <div class="form-row">
        <b-form-group
          id="input-group-3"
          label="Estado"
          label-for="input-1"
          class="col-md-4"
        >
          <b-form-select
            id="Estado"
            value-field="estado"
            text-field="descripcion"
            :options="Estados"
            v-model="PlanUsuario.estado"
            class="p-2 px-4 btn-xs"
          >
          </b-form-select>
        </b-form-group>
      </div>
      <hr />
      <div class="float-right">
        <b-button
          type="button"
          @click="CerrarModal"
          variant="light"
          class="p-2 px-4 btn-xs"
          >Cancelar</b-button
        >
        <b-button
          type="button"
          :disabled="EstadoBoton"
          @click="GuardarPlan()"
          variant="primary"
          class="p-2 px-4 btn-xs"
        >
          <beat-loader :loading="isLoading" :color="'#68d391'" :size="8" />
          <span v-show="!isLoading">Guardar</span>
        </b-button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import axios from "axios";

export default {
  name: "Planes-nuevo",
  props: {
    DialogServicio: {
      type: Boolean,
      required: true,
      default: false,
    },
    Servicio: {
      type: Object,
      required: false,
      default: () => (id_usuario, idplan, fechainicio, fechafin, estado),
    },
  },
  data() {
    return {
      isLoading: false,
      Show: this.DialogServicio,
      EstadoBoton: false,
      empresaestado: false,
      ListaPlanes: {},
      PlanUsuario: {
        id_usuario: "",
        idplan: "",
        fechainicio: "",
        fechafin: "",
        estado: "activo",
      },
      Estados: [
        { estado: "activo", descripcion: "activo" },
        { estado: "inactivo", descripcion: "inactivo" },
      ],
      // validaciones
    };
  },
  watch: {
    DialogServicio() {
      this.Show = this.DialogServicio;
    },
  },
  mounted() {
    //this.id_usuario =
    this.GetPlanes();
  },
  created() {},
  computed: {},
  methods: {
    GetPlanes() {
      let me = this;
      axios({
        method: "post",
        url: "ApiWeb/PlanLista.php",
      })
        .then(function(response) {
          me.ListaPlanes = response.data.data;
        })
        .catch(function(error) {
          //console.log(error);
        });
    },

    ValidarForm() {
      var estado = true;
      //if(this.Cliente.IdCliente.length<8){ this.EstadoNroDocumento=estado=false; } else { this.EstadoNroDocumento=true;  }
      //if(this.Cliente.Nombre.length<=3){ this.EstadoNombre=estado=false; } else { this.EstadoNombre=true; }
      return estado;
    },
    GuardarPlan() {
      this.PlanUsuario.id_usuario = this.$route.params.id;
      if (this.ValidarForm()) {
        let me = this;
        this.isLoading = true;
        this.EstadoBoton = true;
        axios({
          method: "post",
          url: "ApiWeb/PlanAsignar2.php",
          data: me.PlanUsuario,
        })
          .then((response) => {
            if (response.data.error) {
              this.makeToast(response.data.mensaje, "warning");
            } else {
              this.makeToast(response.data.mensaje, "success");
              this.CerrarModal();
            }
          })
          .catch(function(error) {
            //console.log(error);
          })
          .finally(() => {
            this.isLoading = false;
            this.EstadoBoton = false;
          });
      }
    },
    makeToast(msg, color) {
      this.toastCount++;
      this.$bvToast.toast(msg, {
        title: "Mensaje Servicio",
        variant: color,
        autoHideDelay: 3000,
        appendToast: false,
      });
    },
    CerrarModal() {
      //this.Limpiar()
      //    //console.log("cerrar modal")
      this.$emit("CerrarModal");
    },
    Limpiar() {
      this.PlanUsuario = {
        idplan: "",
        fechainicio: "",
        fechafin: "",
        estado: "activo",
      };
    },
  },
};
</script>
<style scoped>
::v-deep .myDiv {
  background-color: #ffffff;
}
</style>
